import createReducer from '../../../data/shared/createReducer';
import { SIGN_UP_BUSINESS_SUCCESS, SIGN_UP_BUSINESS_FAILURE, HIDE_SIGN_IN_MODAL } from '../constants/action_types';

const initialState = {
    error : null,
    submitted: false,
    success: false,
    clientData : null
};

const signUpBusinessFailure = (state, action) => ({
    ...state,
    error: "error"
});

const signUpBusinessSuccess = (state, action) => ({
    ...state,
    submitted: true,
    success: true,
});



const unload = (state, action) => ({
    ...initialState
});

const signUpBusinessReducer = createReducer(initialState, {
    [SIGN_UP_BUSINESS_SUCCESS]: signUpBusinessSuccess,
    [SIGN_UP_BUSINESS_FAILURE]: signUpBusinessFailure,
    [HIDE_SIGN_IN_MODAL]: unload,

});

export default signUpBusinessReducer;
